import { Box, Button, Typography, useTheme } from "@mui/material";
import { highlightContent } from "../../data/highlightContent";
import FormatQuoteIcon from "@mui/icons-material/FormatQuote";
import ParallaxBackground from "../common/ParallaxBackground";

const HighlightSection: React.FC = () => {
  const theme = useTheme();

  return (
    <ParallaxBackground
      backgroundImage="/assets/construcción-ingenieros1.jpg"
      minHeight="60vh"
      maxHeight="750px"
      centerContent={true}
      offsetTop={70}
    >
      {/* Contenedor de comillas  */}
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          flexDirection: "column",
          m: 0,
          p: 0,
        }}
      >
        {/* Ícono de comillas */}
        <FormatQuoteIcon
          sx={{
            fontSize: 90,
            color: theme.palette.secondary.main,
            opacity: 0.5,
            mt: 0,
            mr: -2,
          }}
        />

        {/* Frase principal */}
        <Typography
          variant="h2"
          component="h2"
          sx={{
            fontWeight: 800,
            mb: 6,
            color: theme.palette.secondary.main,
          }}
        >
          {highlightContent.phrase}
        </Typography>
      </Box>

      {/* Botón de contacto */}
      <a href={highlightContent.buttonLink} style={{ textDecoration: "none" }}>
        <Button
          variant="contained"
          size="large"
          sx={{
            backgroundColor: theme.palette.background.default,
            color: theme.palette.secondary.main,
            "&:hover": {
              backgroundColor: theme.palette.secondary.contrastText,
            },
          }}
        >
          {highlightContent.buttonLabel}
        </Button>
      </a>
    </ParallaxBackground>
  );
};

export default HighlightSection;
